import React, { PureComponent } from 'react';
import ChatBot from 'bongga-react-simple-chatbot';
import API from '../../utils/api';
import { prepareSteps, checkSteps } from '../../utils/steps';
import { connect } from 'react-redux';
import { setParams } from '../../redux/modules/agent';
import { receiveOptions } from '../../redux/modules/options';
import { receiveModules } from '../../redux/modules/items';
import { receiveProducts } from '../../redux/modules/products';

class Bot extends PureComponent {
  state =  {
    steps: null,
    open: false,
    reset: false,
    products: [],
    items: [],
    options: [],
  }

  resetData = () => {
    const { resetModules, resetOptions } = this.props;

    resetOptions([]);
    resetModules([]);
  }

  onEnd = ({ steps, values }) => {
    const { setParams, onReset } = this.props;

    setParams({});
    setTimeout(() => {
      this.setState({ open: false, reset: true }, () => {
        if(onReset) onReset();
      });
    }, 2000);
  }

  onToggle = ({ opened }) => {
    this.setState(state => ({ open: !state.open }))
  }

  componentDidUpdate(props, state) {
    if (
      this.state.products.length > 0 &&
      state.products !== this.state.products
    ) {
      this.props.setProducts(this.state.products);
    }
  }

  static getDerivedStateFromProps(props, state) {
    const { modules, options } = props;

    if(!state.reset) {
      if (
        state.steps &&
        state.steps.length > 0 &&
        modules.length > 0 &&
        modules !== state.items
      ) {
        let data = modules.map(item => ({
          value: item.id,
          label: item.name,
          trigger: ({ value, steps }) => 'options-step-one'
        }));

        const step = { id: 'modules-step-three', options: data };

        return {
          steps: checkSteps(state.steps, state.open && step),
          items: modules,
        }
      }

      if (
        state.steps &&
        state.steps.length > 0 &&
        options !== state.options
      ) {
        let data = options.map(item => ({
          value: item.id,
          label: item.name,
          trigger: ({ value, steps }) => 'confirm'
        }));

        if(data.length === 0) {
          data = [{ value: -1, label: 'Continuar', trigger: () => 'empty-options' }];
        }

        let step = { id: 'options-step-three', options: data };

        return {
          steps: checkSteps(state.steps, state.open && step),
          options,
        }
      }
    } else {
      return {
        options: [],
        items: [],
        steps: props.defaultSteps,
      }
    }

    return null;
  }

  async componentDidMount() {
    let products = await API.getProducts();

    products = products.data.items
    const steps = prepareSteps(products);

    this.resetData();
    this.setState({ steps, products });
  }

  render() {
    const { steps, open, reset } = this.state;

    if(!steps) return null;

    return (
      <ChatBot
        reset={reset}
        botAvatar="/botAvatar.svg"
        floating
        floatingIcon="/botAvatar.svg"
        opened={open}
        placeholder="¿Qué duda tienes?"
        headerTitle="Sarah"
        steps={steps}
        handleEnd={this.onEnd}
        toggleFloating={this.onToggle}
      />
    );
  }
}

const stateToProps = state => ({
  products: state.products.data,
  modules: state.items.data,
  options: state.options.data,
});

const actionsToProps = dispatch => ({
  setParams: data => dispatch(setParams(data)),
  resetOptions: data => dispatch(receiveOptions(data)),
  resetModules: data => dispatch(receiveModules(data)),
  setProducts: data => dispatch(receiveProducts(data)),
})

export default connect(stateToProps, actionsToProps)(Bot);
